import React, { useState, useEffect } from "react";
import { toFroApi } from "../../api/toFroRegisterApi";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import "../../styles/markReturnedModal.css";

const ViewMovementModal = ({ movementId, onClose }) => {
  const [movement, setMovement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (movementId) {
      fetchMovement();
    }
  }, [movementId]);

  const fetchMovement = async () => {
    try {
      setLoading(true);
      const response = await toFroApi.getMovement(movementId);
      setMovement(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      1: { text: "OUT", className: "mrm-status--out" },
      2: { text: "RETURNED", className: "mrm-status--returned" },
    };

    const config = statusConfig[status] || statusConfig[1];
    return (
      <span className={`mrm-status-tag ${config.className}`}>
        {config.text}
      </span>
    );
  };

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "N/A";
    return new Date(dateTime).toLocaleString();
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString();
  };

  const calculateDuration = (outTime, inTime) => {
    if (!outTime || !inTime) return "N/A";
    const out = new Date(outTime);
    const inDate = new Date(inTime);
    const diffMs = inDate - out;
    const diffMins = Math.floor(diffMs / 60000);
    return `${diffMins} minutes`;
  };

  if (!movementId) return null;

  return (
    <div className="mrm-modal-overlay">
      <div className="mrm-modal">
        <div className="mrm-modal__header">
          <h2 className="mrm-modal__title">
            Movement Details
          </h2>
        </div>
        
        <div className="mrm-modal__body">
          {loading ? (
            <div className="mrm-loading">
              <div className="mrm-spinner"></div>
              <p>Loading movement details...</p>
            </div>
          ) : error ? (
            <div className="mrm-error-message">
              {error}
            </div>
          ) : movement ? (
            <div className="mrm-movement-info">
              <h4>
                Movement Information
              </h4>
              <div className="mrm-movement-info-grid">
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Movement Code</div>
                  <div className="mrm-movement-info-value">{movement.movement_code}</div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Status</div>
                  <div className="mrm-movement-info-value">
                    {getStatusBadge(movement.status_id)}
                  </div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Staff Name</div>
                  <div className="mrm-movement-info-value">
                    {movement.name || movement.staff_user_id}
                  </div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Designation</div>
                  <div className="mrm-movement-info-value">{movement.designation}</div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Purpose</div>
                  <div className="mrm-movement-info-value">
                    {movement.purpose_name || movement.purpose_id}
                  </div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Place Visited</div>
                  <div className="mrm-movement-info-value">{movement.place_visited}</div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Movement Date</div>
                  <div className="mrm-movement-info-value">{formatDate(movement.movement_date)}</div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Out Time</div>
                  <div className="mrm-movement-info-value">{formatDateTime(movement.out_time)}</div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">In Time</div>
                  <div className="mrm-movement-info-value">
                    {movement.in_time ? formatDateTime(movement.in_time) : "Still OUT"}
                  </div>
                </div>
                <div className="mrm-movement-info-item">
                  <div className="mrm-movement-info-label">Duration</div>
                  <div className="mrm-movement-info-value">
                    {calculateDuration(movement.out_time, movement.in_time)}
                  </div>
                </div>
              </div>

              {movement.remarks && (
                <div style={{ marginTop: "1rem" }}>
                  <h4 style={{ fontSize: "0.875rem", fontWeight: "600", color: "#374151", marginBottom: "0.5rem" }}>
                    Remarks
                  </h4>
                  <div style={{ 
                    background: "#f8fafc", 
                    border: "1px solid #e2e8f0", 
                    borderRadius: "0.5rem", 
                    padding: "0.75rem",
                    fontSize: "0.875rem",
                    color: "#374151"
                  }}>
                    {movement.remarks}
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>

        <div className="mrm-modal__footer">
          <GlobalButton
            onClick={onClose}
            variant="primary"
            size="md"
            className="mrm-button--secondary"
          >
            Close
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default ViewMovementModal;
